<template>
    <div class="costomer-auth-manage">
        <Paper class="costomer-auth-manage-paper">
            <list-layout-paper>
                <template slot="header-search" class="searchBox">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        :showResetBtn="true"
                        @search-change="contractList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="刷新"
                        @click="refresh"
                        plain>
                        <span class="icon iconfont icon-refresh"></span>
                    </lotsButton>
                    <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                        <el-button
                        icon="iconfont icon-list_install"
                        type="primary"
                        size="mini"
                        :title="'列配置'"
                        @click="showColumnConfigDialog"
                        plain />
                    </el-tooltip>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <table-box
                        ref="clientOrder"
                        :height="tableHeight"
                        v-loading="contractList.tableLoading"
                        :selection="config.selection"
                        :index="config.index"
                        :columns="config.tableData.columns"
                        :rows="contractList.totalData">
                        <template v-slot:col-append="{ col, row }">
                            <div v-if="col.prop === 'businessType'">{{col.prop === 'businessType' ? row.busiLabelList:row.businessType}}</div>
                        </template>
                    </table-box>
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="contractList.sizeChange"
                        :current-page.sync="contractList.pageNo"
                        @current-change="contractList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="contractList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
            <!-- 表格列配置弹框 -->
            <column-config
                :pageID="config.name"
                :initColumns="config.tableData.columns"
                ref="otpColumnConfig"
                @header-change="config.tableData.columns = $event"
            />
        </Paper>
    </div>
</template>
<script>
import { ref, reactive, onMounted } from '@vue/composition-api';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import tableBox from '@/components/lots/tableBox/Index';
import { getCustomerAuthInfoPage } from '@mdm/api/customer/customerAuth.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { config as configStatic } from './config';
import utils from '@/components/utils/common.js';
import lotsButton from '@/components/lots/lotsButton';
import columnConfig from '@/components/lots/columnConfig/Index';
import store from '@/store';

export default {
    name: 'customer',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        tableBox,
        lotsPagination,
        lotsButton,
        columnConfig
    },
    props: {},
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const { user } = store.getters;
        const config = reactive(configStatic);
        const activeTabs = ref('theList');
        const tabList = ref([]); // 打开的详情tab页集
        class ContractListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list;
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }
        const contractList = new ContractListClass({
            Api: {
                listApi: getCustomerAuthInfoPage // 查询接口
            }
        });
        onMounted(async () => {
            const queryParams = {
                updateTime: utils.defaultDate('90') // 默认选中前90天
            };
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
        });
        const removeTab = (targetName) => { // 删除详情标签
            if (activeTabs.value === targetName) {
                activeTabs.value = 'theList';
            }
            tabList.value = tabList.value.filter(
                (tab) => (tab.code + tab.detailPageState) !== targetName
            );
        };
        const refresh = () => {
            contractList.getList();
        };
        // eslint-disable-next-line complexity
        const searchDataFormat = (condition) => {
            if (condition.createTime && condition.createTime.length) {
                condition.startTime = utils.formatDateTime(condition.createTime[0]);
                condition.endTime = utils.formatDateTime(condition.createTime[1]);
                Reflect.deleteProperty(condition, 'createTime');
            }
            if (condition.updateTime && condition.updateTime.length) {
                condition.updateStartTime = utils.formatDateTime(condition.updateTime[0]);
                condition.updateEndTime = utils.formatDateTime(condition.updateTime[1]);
                Reflect.deleteProperty(condition, 'updateTime');
            }
            if (condition.selectList && condition.selectList.length) {
                // condition.crmUserCode = condition.selectList[0].userCode;
                condition.crmUserCodes = condition.selectList.map(item => item.userCode);
            }
            Reflect.deleteProperty(condition, 'selectList');
            Reflect.deleteProperty(condition, 'userName');
            condition.userCode = user.userCode;
            condition.isNew = condition.isNew ? +condition.isNew : null;
            Object.keys(condition).forEach(v => {
                !condition[v] && condition[v] !== 0 && (condition[v] = undefined);
            });
            return condition;
        };
        const holePageLoading = ref(false);
        const otpColumnConfig = ref(null);
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };
        return {
            config,
            activeTabs,
            removeTab,
            holePageLoading,
            contractList,
            searchDataFormat,
            refresh,
            otpColumnConfig,
            showColumnConfigDialog
        };
    }
};
</script>

<style lang="less">
.costomer-auth-manage {
    width: 100%;
    .costomer-auth-manage-paper {
        height: 100%;
    }
    .list-layout-wrapper {
        height: 100%;
    }
    .el-tabs {
        width: 100%;
    }
    .flex-layout .list-main {
        overflow: auto;
    }
    .flex-layout .table {
        overflow-y: auto;
    }
    .layout-content.costomer-auth-manage-paper {
        padding: 0px 0px 0px;
    }
    .col-append-box {
        display: flex;
        align-items: center;
        .col-append-btn {
            padding-bottom: 3px;
            padding-left: 3px;
            .eye-btn {
                display: inline-block;
                width: 10px;
                height: 10px;
                cursor: pointer;
            }
        }
    }
}
</style>
